import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  memberList: [],
  stripeProductsList: []
};

const memberSlice = createSlice({
  name: "member",
  initialState,
  reducers: {
    setMemberList: (state, action) => {
      state.memberList = action.payload;
    },
    setStripeProductsList: (state, action) => {
      state.stripeProductsList = action.payload;
    }
  },
});

export const getMemberList = (state) => state.member.memberList;
export const getStripeProductsList = (state) => state.member.stripeProductsList;
export const { setMemberList, setStripeProductsList } = memberSlice.actions;

export default memberSlice.reducer;
